<template>
    <Link
        as="div"
        :href="
            route('student.study-guides.show-study-guide', {
                study_guide: studyGuide.id,
            })
        "
        class="flex justify-between gap-12 border-b border-gray-325 px-4 py-6 last-of-type:border-b-0 hover:cursor-pointer hover:bg-gray-325/20"
    >
        <div class="">
            <div>
                <span
                    class="text-medium p-.5 mr-2 inline-block rounded bg-primary-525 px-1 text-[14px] text-white"
                    v-if="studyGuide.is_new"
                >
                    New!
                </span>
                <span
                    :class="
                        'text-[16px] font-semibold' +
                        ' ' +
                        (studyGuide.user_history_for_current_user
                            ? 'text-purple-500'
                            : 'text-primary-525')
                    "
                >
                    {{ studyGuide.title }}
                </span>
            </div>
            <div class="flex gap-2 text-[14px] text-gray-700">
                <div class="">
                    <span
                        class="after:content-[',_'] last-of-type:after:content-['']"
                        v-for="focusArea in studyGuide.focus_areas"
                    >
                        {{ focusArea.title }}
                    </span>
                </div>
                <div class="">&raquo;</div>
                <div class="">
                    <span
                        class="after:content-[',_'] last-of-type:after:content-['']"
                        v-for="category in studyGuide.categories"
                    >
                        {{ category.title }}
                    </span>
                </div>
            </div>
        </div>
        <div class="flex flex-col gap-2 text-right">
            <div
                class="whitespace-nowrap text-[16px] text-gray-700"
                v-if="studyGuide.est_read_time >= 1"
            >
                {{ studyGuide.est_read_time }} min read
            </div>
        </div>
    </Link>
</template>
<script>
export default {
    name: "StudentStudyGuideRow",
    props: {
        studyGuide: {},
    },
};
</script>
